import React, { useEffect, useState } from 'react'
// import { generateUniqueId } from '../../utils/idGenerator'
import Row from './row'

interface ContainerProps {
  dynamicContainerId: string;
  isSelected: boolean;
  layout: number[] | null; // Layout determines the column classes
  onSelect: () => void;
  onChildDrop: (containerId: string, rowId: string, children: { id?: string; type?: string; label?: string; isInfo?: boolean; isMandatory?: boolean }) => void;
  onChildSelect: (childId: string | null, childType: string | null, childLabel: string | null, childInfo: boolean | null, childMandatory: boolean | null) => void;
  getChildrenLengths: any;
  formSettings: any
  getChildSelects?: any
  changedLabel?: any
  setSelectChilds?: any
  selectedContainer?: any
  setContainersData: any
  setSelectedContainer: any
  containerId: any
  clickedId?: any
  rowClassName?: string
  rowData: { id: string; childData: { id: string; type: string; label: string; isInfo: boolean; isMandatory: boolean }[]; isDataRow?: boolean }[],
  selectedRowId?: string | undefined
  selectedChildId: string | null,
  setSelectedChildId: React.Dispatch<React.SetStateAction<string | null>>
  setSelectedWholeRowId: React.Dispatch<React.SetStateAction<string | null>>
  selectedWholeRowId: string | null
  containersData: { id: string, rowData: { id: string; childData: { id: string; type: string; label: string; isInfo: boolean; isMandatory: boolean }[]; isDataRow?: boolean }[] }[],
  setSelectedType: React.Dispatch<React.SetStateAction<string | null>>
  setSelectedSubChild: React.Dispatch<React.SetStateAction<string | null>>
  setSelectedLayout: React.Dispatch<any>
  selectedLayout: any
}
const Container: React.FC<ContainerProps> = (props) => {
  const { dynamicContainerId,
    onChildSelect,
    selectedChildId,
    setSelectedChildId,
    layout,
    onChildDrop,
    getChildrenLengths,
    containersData,
    selectedLayout,
    setSelectedLayout,
    getChildSelects, formSettings, changedLabel, setSelectChilds, selectedContainer, rowData, setContainersData, setSelectedContainer, containerId, selectedRowId, setSelectedWholeRowId, selectedWholeRowId, setSelectedSubChild, setSelectedType } = props
  // const [children, setChildren] = useState<{ id: string; type: string; label: string; isInfo: boolean; isMandatory: boolean; position: string; placeholder: string | null; readonly: boolean | null; disabled: boolean | null }[]>([])
  const [rows, setRows] = useState<{ id: string; childData: { id: string; type: string; label: string; isInfo: boolean; isMandatory: boolean }[]; isDataRow?: boolean }[]>([])
  // const [childLength, setChildLength] = useState<string | null>(null)
  // const generateUniqueid = (type: string) =>
  //   `${type}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
  // const getChildrenLength = (data: any) => {
  //   if (data?.length > 0) {
  //     props.getChildrenLengths(data)
  //   }
  // }

  useEffect(() => {
    setRows(rowData)
  }, [rowData])
  return (
    <>
      <Row
        // key={id}
        rowData={rows}
        dynamicContainerId={dynamicContainerId}
        isSelected={dynamicContainerId === selectedContainer}
        // onSelect={() => {
        //   setSelectedContainer(selectedContainer === id ? null : id)
        // }}
        layout={layout}
        onChildDrop={onChildDrop}
        onChildSelect={onChildSelect}
        getChildrenLengths={getChildrenLengths}
        getChildSelects={getChildSelects}
        formSettings={formSettings} changedLabel={changedLabel}
        //   clickedId={clickedId}
        // rowClassName={containerClassName} 
        setSelectChilds={setSelectChilds}
        setContainersData={setContainersData}
        setSelectedContainer={setSelectedContainer}
        containerId={containerId}
        selectedRowId={selectedRowId}
        selectedChildId={selectedChildId}
        setSelectedChildId={setSelectedChildId}
        setSelectedWholeRowId={setSelectedWholeRowId}
        selectedWholeRowId={selectedWholeRowId}
        containersData={containersData}
        setSelectedSubChild={setSelectedSubChild}
        setSelectedType={setSelectedType}
        selectedLayout={selectedLayout}
        setSelectedLayout={setSelectedLayout}
      />

    </>
  )
}
export default Container
